(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-grid"] && !Shopify.designMode) return;
  try {
    document.addEventListener('sezerium:js:unload', (e) => {
      setTimeout(() => document.querySelector('.sezerium-loading')?.classList?.replace('sezerium-loading', 'sezerium-loaded'), 500);
  });
  document.addEventListener('DOMContentLoaded', () => {
    if (typeof SezeriumCollection === 'undefined') {
        document.querySelector('.sezerium-loading')?.classList?.replace('sezerium-loading', 'sezerium-loaded');
    }
});
  } catch(e) { console.error(e); }
})();

})();
